export default __webpack_public_path__ + "2fc00e1daf5dbb6aaa620e7a301c6a35.png";